import type { FeatureFlag } from '@/definitions/featureFlags'

/** Which way a staged save moves the "on for all orgs" switch, if at all. */
export type AllOrgsChange = 'TURNING_ON' | 'TURNING_OFF' | 'UNCHANGED'

/**
 * Read a staged "on for all orgs" value against the stored flag.
 *
 * Compared against what is stored rather than read on its own, so a switch left
 * as it was says nothing: the banner and the confirmation are both about a change
 * the operator is about to make, not about the state the flag is already in.
 *
 * A flag that is not live is always `UNCHANGED`. Neither direction of this switch
 * reaches a practice while the flag is off, so there is nothing to warn about.
 *
 * Kept out of the component so it can be tested without rendering.
 */
export const allOrgsChange = (
  flag: FeatureFlag,
  stagedEnableAllOrgs: boolean,
): AllOrgsChange => {
  if (!flag.enabled || stagedEnableAllOrgs === flag.enable_all_orgs) {
    return 'UNCHANGED'
  }
  return stagedEnableAllOrgs ? 'TURNING_ON' : 'TURNING_OFF'
}
